export const FILTERED_OUTPUT_DATA_REQUEST = "FILTERED_OUTPUT_DATA_REQUEST";
export const FILTERED_OUTPUT_DATA_SUCCESS = "FILTERED_OUTPUT_DATA_SUCCESS";
export const FILTERED_OUTPUT_DATA_FAILURE = "FILTERED_OUTPUT_DATA_FAILURE";
